import React, { PureComponent } from 'react';

export default (className) => (WrappedComponent) => {
  class WithTouch extends PureComponent {
    constructor(props) {
      super(props);

      this.toggleActive = this.toggleActive.bind(this);

      this.state = { active: false };
    }

    toggleActive() {
      const { active } = this.state;

      this.setState({ active: !active });
    }

    render() {
      const { active } = this.state;

      return (
        <WrappedComponent
          className={active ? className : ''}
          onTouchStart={this.toggleActive}
          onTouchEnd={this.toggleActive}
          {...this.props}
        />
      );
    }
  }

  return WithTouch;
};
